import { Crown, Package, Share2, Skull, Timer } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchDeliveryRecords, fetchHallOfFame } from "../utils/rewards";
import { downloadShareCard } from "../utils/shareCard";

const badgeTier = (b) => (b.startsWith("30") ? "is-legend" : b.startsWith("14") ? "is-elite" : "");
const formatClearTime = (seconds) => `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;

export function HallOfFame() {
  const [holders, setHolders] = useState(null);
  const [routes, setRoutes] = useState(null);

  useEffect(() => {
    fetchHallOfFame().then(setHolders).catch(() => setHolders([]));
    fetchDeliveryRecords().then(setRoutes).catch(() => setRoutes({ fastest: [], most: [] }));
  }, []);

  if (holders === null) return null;

  const hasRouteRecords = routes && (routes.fastest.length > 0 || routes.most.length > 0 || (routes.bounty || []).length > 0);

  return (
    <section className="hall-of-fame" data-testid="hall-of-fame-strip">
      <div className="hall-of-fame-head">
        <span className="hall-of-fame-eyebrow">DOLO REWARDS // HALL OF FAME</span>
        <h2>
          <Crown size={20} /> BADGE HOLDERS OF THE MESH
        </h2>
        <p>Tags that held a daily streak long enough to forge a permanent badge. Claim your free Bio Hack tube every day and etch yours here.</p>
      </div>
      {holders.length === 0 ? (
        <p className="hall-of-fame-empty" data-testid="hall-of-fame-empty">
          NO BADGES FORGED YET — SEVEN DAYS OF DAILY TUBES ETCHES THE FIRST NAME.
        </p>
      ) : (
        <ul className="hall-of-fame-list">
          {holders.map((row) => (
            <li key={row.tag} data-testid={`hall-of-fame-${row.tag.toLowerCase()}`}>
              <strong>{row.name || row.tag}</strong>
              <span className="hall-of-fame-badges">
                {(row.badges || []).map((b) => (
                  <b className={`rewards-row-badge ${badgeTier(b)}`} key={b}>
                    {b}
                  </b>
                ))}
              </span>
              <em>{row.points} PTS</em>
              {row.crow_kills > 0 && (
                <em className="hall-of-fame-crows" data-testid={`hall-of-fame-crows-${row.tag.toLowerCase()}`}>CROWS ×{row.crow_kills}</em>
              )}
              <button
                type="button"
                className="share-card-btn"
                title="Download hall-of-fame card"
                onClick={() => downloadShareCard({ name: row.name || row.tag, tag: row.tag, points: row.points, badges: row.badges })}
                data-testid={`share-card-${row.tag.toLowerCase()}`}
              >
                <Share2 size={12} />
              </button>
            </li>
          ))}
        </ul>
      )}
      {hasRouteRecords ? (
        <div className="hall-of-fame-routes" data-testid="hall-of-fame-routes">
          <div className="hall-of-fame-routes-head">
            <Package size={15} /> DELIVERY ROUTE RECORDS — WASTELAND RUN
          </div>
          <div className="hall-of-fame-routes-grid">
            <div className="hall-of-fame-route-col" data-testid="route-fastest-list">
              <span className="hall-of-fame-route-title"><Timer size={12} /> FASTEST ROUTE CLEARS</span>
              {routes.fastest.length === 0 ? (
                <p className="hall-of-fame-route-empty">NO ROUTE CLEARED YET — 20 DELIVERIES ETCHES THE FIRST TIME.</p>
              ) : (
                <ol>
                  {routes.fastest.map((row, index) => (
                    <li key={row.tag} data-testid={`route-fastest-${index}`}>
                      <strong>{row.name || row.tag}</strong>
                      <em>{formatClearTime(row.seconds)}</em>
                    </li>
                  ))}
                </ol>
              )}
            </div>
            <div className="hall-of-fame-route-col" data-testid="route-most-list">
              <span className="hall-of-fame-route-title"><Package size={12} /> MOST DELIVERIES LOGGED</span>
              {routes.most.length === 0 ? (
                <p className="hall-of-fame-route-empty">NO DELIVERIES LOGGED YET — 30,000 PTS LANDS THE FIRST.</p>
              ) : (
                <ol>
                  {routes.most.map((row, index) => (
                    <li key={row.tag} data-testid={`route-most-${index}`}>
                      <strong>{row.name || row.tag}</strong>
                      <em>{row.deliveries}/20{row.clears > 0 ? ` · CLEARS ×${row.clears}` : ""}</em>
                    </li>
                  ))}
                </ol>
              )}
            </div>
            <div className="hall-of-fame-route-col" data-testid="route-bounty-list">
              <span className="hall-of-fame-route-title"><Skull size={12} /> BOSS BOUNTY — PLATING SHATTERS</span>
              {(routes.bounty || []).length === 0 ? (
                <p className="hall-of-fame-route-empty">NO BOUNTIES PAID YET — SHATTER THE APEX PLATING IN A BOSS WAVE.</p>
              ) : (
                <ol>
                  {(routes.bounty || []).map((row, index) => (
                    <li key={row.tag} data-testid={`route-bounty-${index}`}>
                      <strong>{row.name || row.tag}</strong>
                      <em>SHATTERS ×{row.shatters}</em>
                    </li>
                  ))}
                </ol>
              )}
            </div>
          </div>
        </div>
      ) : null}
      <Link to="/rewards" className="hall-of-fame-link" data-testid="hall-of-fame-link">
        ENTER DOLO REWARDS →
      </Link>
    </section>
  );
}
